import Swiper from 'swiper/bundle';
if(typeof window.Swiper === 'undefined') window.Swiper = Swiper;

import afg_helpers from './js/helpers.js';
if(typeof window.afg_helpers === 'undefined') window.afg_helpers = afg_helpers;
import afgBlog from './js/blog.js';
if(typeof window.afgBlog === 'undefined') window.afgBlog = afgBlog;

import singlePost from './js/single.js';
if(typeof window.singlePost === 'undefined') window.singlePost = singlePost;

afg_helpers.scrollDirection();
afg_helpers.addHeaderOnMobileMenu();
afg_helpers.setPalettes();
afg_helpers.setScrollToAnchor();
afg_helpers.modals('.afg-modal');